import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        rolesForm: '=',
        isEvaluableReport: '=',
        statisticsText: '='
    },
    template: `
        <p ng-bind-html="vm.statisticsText"></p>
        <h3>{{ 'report.evaluation.Feedback:' | translate }}</h3>
        <evaluation-public-report-role-desktop roles-form="vm.rolesForm" />
        <evaluation-public-report-role-mobile roles-form="vm.rolesForm" />
        <h3 ng-if="vm.isEvaluableReport">{{ 'report.Feedback was sought:' | translate }}</h3>
        <h4 ng-if="vm.isEvaluableReport" ng-repeat-start="(role, label) in vm.EVALUATION_ROLE_ENUM.LABELS">{{ label }}</h4>
        <ul ng-if="vm.isEvaluableReport" ng-repeat-end>
            <li ng-repeat="evaluator in vm.rolesForm.evaluatorsByRole[role]">{{ evaluator }}</li>
            <li ng-if="!vm.rolesForm.evaluatorsByRole[role]">-</li>
        </ul>
    `
})
export default class {
    constructor (EVALUATION_ROLE_ENUM) {
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/role/index.js